import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { onMounted, onBeforeUnmount, reactive, ref, provide } from 'vue';
  import NavHelper from './components/navigate-helper.vue';
  import { useRoute } from 'vue-router';
  import { AdminSdk } from '@/components/custom/admin-sdk';
  import { ICustomPage } from '@/types/custom-page';
  import InjectImages from '@/templates/images';

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const adminSdk = new AdminSdk();
  const { query: { sourceId } } = useRoute();
  const pageInjectData = reactive<{[key: string]: any}>({ Images: InjectImages });
  const pageInited = ref(false);
  const components = ref([]);
  let customPage: ICustomPage;

  async function fetchData() {
    if (customPage) {
      const { target_type, target_id } = customPage;
      if (target_type === 'Program') {
        const { data: program } = await adminSdk.request({
          data: {
            method: 'get',
            url: `/programs/${target_id}`,
          }
        });
        if (pageInjectData.program) {
          Object.assign(pageInjectData.program, program);
        } else {
          pageInjectData.program = program;
        }
      }
    }
  }

  onMounted(async () => {
    const { data } = await adminSdk.request({ data: { method: 'get', url: `/custom_pages/${sourceId}` } });
    customPage = data;
    await fetchData();
    try {
      components.value = JSON.parse(data.configs).components || [];
    } catch (e) {
      components.value = [];
    }
    pageInited.value = true;
  });

  onBeforeUnmount(() => {
    adminSdk.destroy();
  });

  provide('refreshPageData', fetchData);
  provide('editorMode', true);

return (_ctx: any,_cache: any) => {
  const _component_AppPageEditor = _resolveComponent("AppPageEditor")!
  const _component_AppCustomPageContainer = _resolveComponent("AppCustomPageContainer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppCustomPageContainer, _normalizeProps(_guardReactiveProps(_unref(pageInjectData))), {
      default: _withCtx(() => [
        (pageInited.value)
          ? (_openBlock(), _createBlock(_component_AppPageEditor, _mergeProps({
              key: 0,
              "init-components": components.value,
              "source-id": (_unref(sourceId) as string)
            }, _unref(pageInjectData)), null, 16, ["init-components", "source-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 16),
    _createVNode(NavHelper)
  ], 64))
}
}

})